import { getLocalTime } from '../time/time';

export const getCurrentServiceRunDayEnd = timezone => (
	getLocalTime(timezone).endOf('day').unix()
);

// Re-resolve before every list request so a mounted Run screen advances at state-local midnight.
export const resolveServiceRunListQueryVariables = (variables, timezone, refreshPlannedToDate) => {
	if (!refreshPlannedToDate || !variables?.filter?.plannedToDate) {
		return variables;
	}

	return {
		...variables,
		filter: {
			...variables.filter,
			plannedToDate: getCurrentServiceRunDayEnd(timezone),
		},
	};
};
